const BULK_USER_TEMPLATE_CSV =
  'FirstName,LastName,Email,UserGroup,Department,CardNumber,DeviceInfo\n';

const TEMPLATE_FILENAME = 'bulk-user-import-template.csv';

/** Download an empty CSV template for bulk user import. */
export function downloadBulkUserImportTemplate(): void {
  const blob = new Blob([BULK_USER_TEMPLATE_CSV], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = TEMPLATE_FILENAME;
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}
